import { Component, Input } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PlatformCompanyRegistrationDto } from '@well/platform-administration/company/domain';
import { constants } from '@well/infra/constants';
import { FloatLabel } from 'primeng/floatlabel';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { BsInputTextDirective } from '@well/iriro-frontend-libs/bs-component-store';

@Component({
    selector: 'well-platform-company-registration-inputs',
    imports: [FloatLabel, FormsModule, TranslateModule, BsInputTextDirective, FormInlineErrorDirective],
    templateUrl: './platform-company-registration-inputs.component.html',
    styleUrls: ['./platform-company-registration-inputs.component.scss'],
    viewProviders: [constants.nestedTemplateFormsViewProviders]
})
export class PlatformCompanyRegistrationInputsComponent {
  @Input() platformCompanyRegistrationDTO: PlatformCompanyRegistrationDto = new PlatformCompanyRegistrationDto();

}
